import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosPayment } from "../utils/request";
import { giftCardApis } from "../utils/apis";
import { getUsers } from "../utils/getUser";

export const listAllGiftCards = createAsyncThunk(
  "listAllGiftCards",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();
      const response = await axiosInstance.get(giftCardApis.getAllGiftCards);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);
export const listAllGiftCardsManager = createAsyncThunk(
  "listAllGiftCardsManager",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();
      const response = await axiosInstance.get(
        giftCardApis.getAllGiftCardsManager
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createRedemption = createAsyncThunk(
  "createRedemption",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();

      const response = await axiosInstance.post(
        giftCardApis.createRedemption,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createGiftCard = createAsyncThunk(
  "createGiftCard",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();

      const response = await axiosInstance.post(
        giftCardApis.createGiftCard,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateGiftCard = createAsyncThunk(
  "updateGiftCard",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();
      const response = await axiosInstance.post(
        giftCardApis.updateGiftCard,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

/* WITHDRAWAL REQUEST */

export const resendWithdrawalInvoice = createAsyncThunk(
  "resendWithdrawalInvoice",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();
      const response = await axiosInstance.post(
        `${giftCardApis.resendWithdrawalInvoice}?withdrawal_id=${payload?.id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createWithdrawalRequest = createAsyncThunk(
  "createWithdrawalRequest",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();

      const response = await axiosInstance.post(
        giftCardApis.createWithdrawalRequest,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateWithdrawalRequest = createAsyncThunk(
  "updateWithdrawalRequest",
  async (payload) => {
    try {
      const axiosInstance = createAxiosPayment();

      const response = await axiosInstance.post(
        giftCardApis.updateWithdrawalRequest,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);
export const downloadWithdrawalInvoice = createAsyncThunk(
  "downloadWithdrawalInvoice",
  async ({ id, payload }) => {
    try {
      const axiosInstance = createAxiosPayment();

      const response = await axiosInstance.post(
        `${giftCardApis.downloadWithdrawalInvoice}?id=${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${getUsers()?.access_token}`,
            "Content-Type": "application/x-www-form-urlencoded",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const uploadWithdrawalReceipt = createAsyncThunk(
  "uploadWithdrawalReceipt",
  async ({ docFormData }) => {
    try {
      const axiosInstance = createAxiosPayment();
      const response = await axiosInstance.post(
        giftCardApis.uploadWithdrawalRequest,
        docFormData,
        {
          headers: {
            Authorization: `Bearer ${getUsers()?.access_token}`,
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const giftcardSlice = createSlice({
  name: "giftcardSlice",
  initialState: {
    giftCards: null,
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(listAllGiftCards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(listAllGiftCards.fulfilled, (state, action) => {
        state.loading = false;
        state.giftCards = action.payload;
      })
      .addCase(listAllGiftCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default giftcardSlice.reducer;
